import PaneelNavigatie from "../../components/Paneel/paneelNavigatie";

import { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import config from "../../config";
import axios from "axios";

//import FunctieVolgorde from "../../components/Paneel/Praesidium/functieVolgorde";
import FunctieToevoegen from "../../components/Paneel/Praesidium/functieToevoegen";
//import FunctieBewerken from "../../components/Paneel/Praesidium/functieBewerken";
//import LidToevoegen from "../../components/Paneel/Praesidium/lidToevoegen";
import LidBewerken from "../../components/Paneel/Praesidium/lidBewerken";

import Modal from "../../components/modal";
import { Helmet } from "react-helmet";
import { PRAESIDIUM_FUNCTIES } from "../../components/Choices";

import { check_login } from "../../auth/auth";
import { check_permission } from "../../auth/auth";

function Paneel_Praesidium() {
	const [claims] = useState(check_login(true));
	const [allowed] = useState(check_permission("praesidium", true));

	const [praesidiumBewerkModal, setPraesidiumBewerkModal] = useState(false)
	const [lidToevoegenModal, setLidToevoegenModal]= useState(false)
	useEffect(() => {
		Aos.init();
	});

	const [praesidium, setPraesidium] = useState([]);

	useEffect(() => {
		Render();
	}, []);

	function Render() {
		axios.get(config.api_url + "/praesidia/?active=true").then((response) => {
			setPraesidium(response.data.data[0].praesidium);
		});
	}

	return (
		<>
			{claims && allowed && (
				<div className="dark:bg-zinc-900">
					<PaneelNavigatie />
					<Helmet>
						<title>Paneel - Praesidium - Hermes Gent</title>
						<meta name="description" content="Hermes Gent Cursusverkoop" />
					</Helmet>
					<div className="lg:w-8/12 w-11/12 pt-10 pb-40 mx-auto ">
						<div className="w-full bg-red-500 text-white px-6 py-4 rounded-md font-semibold dark:bg-red-800">Deze pagina is nog in onderhoud!</div>
						<div className="flex flex-col lg:flex-row items-center mb-8 border-b-2 border-zinc-200 dark:border-zinc-800 p-6 pl-0 pb-2">
							<h1 className="font-bold text-4xl uppercase text-zinc-800  dark:text-zinc-300">Praesidium</h1>

							<div className="flex flex-col md:flex-row items-center">
								<Modal
									condition={lidToevoegenModal} setCondition={setLidToevoegenModal}
									boxClasses="w-full md:w-8/12 xl:w-5/12 md:mx-auto mt-12 lg:mt-36 mb-16"
									openButtonClasses="flex hidden items-center md:border-r-2 md:border-zinc-200 h-14 px-6 transition-colors text-zinc-500 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-300 dark:border-zinc-800"
									openButtonValue={
										<>
											<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
											</svg>
											<span className="pl-2">FUNCTIE TOEVOEGEN</span>
										</>
									}>
									<FunctieToevoegen reRender={() => Render()} />
								</Modal>

								{/*<Modal
									boxClasses="w-full md:w-8/12 xl:w-5/12 md:mx-auto mt-12 lg:mt-36 mb-16"
									openButtonClasses="flex hidden items-center md:border-r-2 md:border-zinc-200 h-14 px-6 transition-colors text-zinc-500 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-300 dark:border-zinc-800"
									openButtonValue={
										<>
											<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
											</svg>
											<span className="pl-2">VOLGORDE WIJZIGEN</span>
										</>
									}>
									<FunctieVolgorde reRender={() => Render()} />
								</Modal>

								<Modal
									boxClasses="w-full md:w-8/12 xl:w-5/12 md:mx-auto mt-12 lg:mt-36 mb-16"
									openButtonClasses="flex items-center h-14 px-6 transition-colors text-zinc-500 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-300"
									openButtonValue={
										<>
											<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
											</svg>
											<span className="pl-2">LID TOEVOEGEN</span>
										</>
									}>
									<LidToevoegen reRender={() => Render()} />
								</Modal>*/}
							</div>
						</div>
						{Object.keys(PRAESIDIUM_FUNCTIES).map((name) => {
							return (
								<div key={name}>
									<div className="flex items-center my-6 mt-12 justify-center md:justify-start">
										<h2 className="font-bold text-3xl uppercase text-zinc-600 dark:text-zinc-400">{name}</h2>

										{/*<Modal
										boxClasses="w-full md:w-8/12 xl:w-5/12 md:mx-auto mt-12 lg:mt-36 mb-16"
										openButtonClasses="dark:text-zinc-400 p-2 rounded-full text-zinc-500 text-md transition-colors hover:text-blue-600 dark:hover:text-blue-400"
										openButtonValue={
											<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
											</svg>
										}>
										<FunctieBewerken functieID={functie.id} reRender={() => Render()} />
									</Modal>*/}
									</div>
									{praesidium &&
										praesidium.map((lid, i) => {
											return (
												<>
													{name === lid.functie ? (
														<div key={i} className="flex flex-row items-center relative shadow w-100 p-3 rounded-xl mb-2 dark:bg-black/20">
															<div className="flex-grow flex items-center pl-6">
																<img className="w-16 h-16 object-cover rounded-full shadow-lg" src={lid.photo ? lid.photo : config.base_url + "/images/placeholder.jpg"} alt="" />
																<h1 className="text-gray-500 dark:text-gray-300 text-xl pl-6">
																	{lid.voornaam} {lid.achternaam}
																</h1>
																<h3 className="ml-2 hidden md:block text-gray-500 dark:text-gray-300">
																	{lid.telephone_number ? (
																		<>
																			/{" "}
																			<a className="text-blue-700 dark:text-blue-300" href={"tel:" + lid.telephone_number}>
																				{lid.telephone_number}
																			</a>
																		</>
																	) : (
																		<></>
																	)}
																</h3>
															</div>
															<Modal
																condition={praesidiumBewerkModal} setCondition={setPraesidiumBewerkModal}
																boxClasses="w-full md:w-8/12 xl:w-5/12 md:mx-auto mt-12 lg:mt-36 mb-16"
																openButtonClasses="dark:text-zinc-400 p-2 rounded-full text-zinc-500 text-md transition-colors hover:text-blue-600 dark:hover:text-blue-400 mr-3"
																openButtonValue={
																	<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
																		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
																	</svg>
																}>
																<LidBewerken lidID={lid.id} reRender={() => Render()} />
															</Modal>
														</div>
													) : (
														""
													)}
												</>
											);
										})}
								</div>
							);
						})}
						<div></div>
					</div>
					
				</div>
			)}
		</>
	);
}

export default Paneel_Praesidium;
